<template>
  <a-modal
    title="物流更新"
    width="800px"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:30%;height: 55%;overflow-y: hidden">
    <a-form-model :model="form" ref="formRef" label-width="120px" :rules="validatorRules">
       <a-form-model-item label="物流时间" prop="logisticsTime">
         <j-date v-model="form.logisticsTime" :show-time="true" />
       </a-form-model-item>
       <a-form-model-item label="到达站点/地点"  prop="address">
         <a-input v-model="form.address"  />
       </a-form-model-item>
        <a-form-model-item label="物流详情">
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
          >
            <span slot="action" slot-scope="text, record">
              <a-popconfirm  title="确定删除吗?" @confirm="() => del(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </a-form-model-item>
    </a-form-model>
  </a-modal>

</template>
<script>
import JDate from '@/components/jeecg/JDate'
import { Logistics } from '@api/logistics'
import moment from 'moment/moment'
import {JeecgListMixin} from "@/mixins/JeecgListMixin";
export default {
  name: "LogisticsInfoModal",
  mixins: [JeecgListMixin],
  components: {
    JDate
  },
  data() {
    return {
      form: {
        id:null,
        logisticsId:null,
        createTime:null,
        logisticsTime:null,
        createBy:null,
        creator:null,
        address:null,
        tenantId:null
      },
      title:'',
      formRef:null,
      confirmLoading:false,
      visible: false,
      dataSource:[],
      // 表头
      columns: [
        { title: '序号', dataIndex: '', key: 'rowIndex', width: 50, align: "center", customRender: function (t, r, index) {return parseInt(index) + 1;}},
        { title: '物流时间', dataIndex: 'logisticsTime',align: "center",width:300, ellipsis:true },
        { title: '地点', dataIndex: 'address',align: "center",width:120, ellipsis:true },
        { title: '更新人', dataIndex: 'creator',align: "center",width:120, ellipsis:true },
        { title: '操作', dataIndex: 'action',align: "center",width:80, scopedSlots: { customRender: 'action' }},
      ],
      validatorRules : {
        logisticsTime: [{ required: true, message: '请选择物流时间!' }],
        address: [{ required: true, message: '请填写地址!' }],
      },
    }
  },
  methods: {
    handleCancel(){
      this.visible = false
    },
    handleOk(){
      this.$refs.formRef.validate( (valid ) =>{
        if (valid) {
          moment(this.form.logisticsTime).format('YYYY-MM-DD HH:mm:ss')
          Logistics.saveItems(this.form).then(() => {
            this.$message.success('操作成功')
            this.$emit('reload')
            this.handleCancel()
            this.form ={
              id:null,
                logisticsId:null,
                createTime:null,
                logisticsTime:null,
                createBy:null,
                creator:null,
                address:null,
                tenantId:null
            }
          })
        }
      })
    },
    del({id}){
      Logistics.itemDelList(id)
      this.$message.success('操作成功')
      this.visible = false
    },
    show(record){
      this.visible = true
      this.form.logisticsId = record.id
      Logistics.itemList(record.id).then(res => {
        this.dataSource = res.data
      })
    }
  },
}

</script>